import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export const multiSelectionToolsMixin = {
  mixins: [checkPermissionsMixin],

  methods: {
    canUseTool(action) {
      if (this.permission) {
        return this.userHasFibercloudPermission(this.permission, action);
      } else {
        return true;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/forms/multipleObjectsSelection/multiSelectionToolsMixin.js